import React, { forwardRef } from 'react';
import { errorSummaryShape } from '../../../../constants/data-shapes/competitions-form';
import isForbidden from '../../../../components/CompetitionsForms/is-forbidden';
import DuplicateEntry from './DuplicateEntry';
import SummaryBox from './SummaryBox';
const ErrorSummary = forwardRef((props, ref) => {
    const { errorsCount, errors } = props;
    if (isForbidden(errors)) {
        return null;
    }
    if (!errorsCount) {
        return null;
    }
    return (React.createElement("div", { ref: ref },
        React.createElement(DuplicateEntry, { errors: errors }),
        React.createElement(SummaryBox, { errors: errors, errorsCount: errorsCount })));
});
export default ErrorSummary;
ErrorSummary.propTypes = errorSummaryShape;
//# sourceMappingURL=index.js.map